import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useAuth } from "./AuthContext";
import { getAccount, updateAccount } from "./api";

export const FAV_LEAGUE_KEY = "rosterly_fav_league";

// Favourite league = the league the app opens in. Account-saved when signed in, this device for guests.
export function useFavLeague() {
    const { user } = useAuth();
    const qc = useQueryClient();
    const { data: account } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: !!user });
    const [local, setLocal] = useState(() => { try { return localStorage.getItem(FAV_LEAGUE_KEY) || ""; } catch { return ""; } });
    const favLeague = (user ? account?.profile?.fav_league : local) || "";
    const toggleFavLeague = (lg) => {
        const next = favLeague === lg ? "" : lg;
        setLocal(next);
        try { if (next) localStorage.setItem(FAV_LEAGUE_KEY, next); else localStorage.removeItem(FAV_LEAGUE_KEY); } catch { /* noop */ }
        if (user) {
            qc.setQueryData(["account"], (p) => (p ? { ...p, profile: { ...(p.profile || {}), fav_league: next } } : p));
            updateAccount({ fav_league: next }).then(() => qc.invalidateQueries({ queryKey: ["account"] })).catch(() => { });
        }
        return next;
    };
    return { favLeague, toggleFavLeague };
}
